export default class Annotation {
  constructor(id, type, coords, conf, label, color_values, skip_zoom, textFields, format) {

    if(typeof skip_zoom == 'undefined') {
      skip_zoom = false
    }

    const tf = textFields || {}

    this.id = id;
    this.type = type;
    this.coords = coords;
    this.conf = conf;
    this.label = label;
    this.color_values = color_values;
    this.selected = false;
    this.show = true;
    this.skip_zoom = skip_zoom
    this.transcript = tf.transcript != null ? String(tf.transcript) : ''
    this.transcript_source = tf.transcript_source != null ? String(tf.transcript_source) : ''
    this.format = format || (Array.isArray(coords) && coords.length === 8 ? 'normalized_quad' : 'normalized_xywh')
  }
}
